<template>
  <div>
    <div class="search-folder px-1">
      <div class="input-group mb-1">
        <input
          v-model="searchCatQuery"
          class="form-control"
          type="text"
          placeholder="tên thư mục"
          aria-label="tên thư mục"
          aria-describedby="my-addon"
          size="sm"
          @input="filterPem"
        >
        <div class="input-group-append">
          <span
            v-if="!searchCatQuery.length"
            class="input-group-text"
          ><feather-icon icon="SearchIcon" /></span>
          <span
            v-if="searchCatQuery.length"
            class="input-group-text"
            @click="filterPem($event, true)"
          ><feather-icon icon="XIcon" /></span>
        </div>
      </div>
    </div>
    <vue-tree-list
      :model="treeData"
      :default-expanded="true"
      @change-name="onEdit"
      @delete-node="onDel"
      @click="clickNodeTree($event,)"
    >
      <span
        slot="addTreeNodeIcon"
        class="icon"
      />
      <span
        slot="addLeafNodeIcon"
        class="icon"
      />
      <span
        slot="editNodeIcon"
        title="Sửa"
        class="icon"
      >
        <feather-icon icon="Edit3Icon" />
      </span>
      <span
        slot="delNodeIcon"
        title="Xóa"
        class="icon"
        @click.prevent=""
      >
        <feather-icon icon="XIcon" />
      </span>
      <span
        slot="leafNodeIcon"
        class="icon"
        @click.prevent=""
      >
        <feather-icon icon="FolderIcon" />
      </span>
      <span
        slot="treeNodeIcon"
        class="icon"
      ><feather-icon icon="FolderIcon" /></span>
    </vue-tree-list>

  </div>
</template>

<script>
import { showToast } from '@/@core/utils/utils'
// import { faL } from '@fortawesome/free-solid-svg-icons'
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list'
import { mapState } from 'vuex'

export default {
  components: {
    VueTreeList,
  },
  data() {
    return {
      defaultNodeOptions: {
        isLeaf: false,
        dragDisabled: true,
        addTreeNodeDisabled: true,
        addLeafNodeDisabled: true,
        editNodeDisabled: true,
        delNodeDisabled: true,
        disabled: false,
        itemType: 'category',
        show: true,
      },
      newTree: [],
      treeData: new Tree([]),
      active_cat_id: 0,
      loading: false,
      oldName: '',
      searchCatQuery: '',
    }
  },
  computed: {
    ...mapState('files', {
      page: state => state.page,
      limit: state => state.limit,
      keyword: state => state.keyword,
      start_date: state => state.start_date,
      end_date: state => state.end_date,
      search_all: state => state.search_all,
    }),
    // currentPage() {
    //   return this.$store.state.files.page
    // },
    // perPage() {
    //   return this.$store.state.files.limit
    // },
    selectedItem: {
      get() { return this.$store.state.files.selected_category; },
      set(val) { },
    },
    // keyword() {
    //   return this.$store.state.files.keyword
    // },
    // searchAll() {
    //   return this.$store.state.files.search_all
    // },
    // start_date() {
    //   return this.$store.state.files.start_date
    // },
    // end_date() {
    //   return this.$store.state.files.end_date
    // },
  },
  watch: {
    '$store.state.files.selected_category': function () {
      this.selectedItem = this.$store.state.files.selected_category;
      this.activeNodeTree(this.selectedItem.id);
    },
    '$store.state.files.created_category': function () {
      this.addCategory(this.$store.state.files.created_category);
    },
    '$store.state.files.show_all_category': function () {
      this.clickNodeTree(this.selectedItem);
    },
    '$store.state.files.deleted_category': function () {
      // console.log('deleted_category: ', this.$store.state.files.deleted_category);
      if (this.$store.state.files.deleted_category) {
        this.deleteNodeTree(this.newTree, this.$store.state.files.deleted_category);
      }
    },
  },
  mounted() {
    this.getAllCategory();
  },
  methods: {
    activeNodeTree(nodeId) {
      const allNodes = document.querySelectorAll('.vtl-node');
      allNodes.forEach((val) => {
        const id = parseInt(val.getAttribute('id'), 0);
        if (id !== nodeId) {
          val.classList.remove('active');
        } else {
          val.classList.add('active');
        }
      });
    },
    clickNodeTree(params) {
      if (params) {
        this.activeNodeTree(params.id);
        if (params.id === 0) {
          params.search_all = 1;
        } else {
          params.search_all = 0;
        }
        const payload = {
          selected_category: params,
          category_items: params.children,
          file_items: [],
          keyword: this.selectedItem && this.selectedItem.id !== params.id ? '' : this.keyword,
          search_all: params.search_all,
        };
        this.$store.dispatch('files/setState', payload);
      }
      this.$store.dispatch('files/setState', {
        loading: true,
      });

      this.$store.dispatch('files/fetchFiles', {
        category_id: params && params.id >= 0 ? params.id : '',
        page: this.page,
        limit: this.limit,
        keyword: this.keyword,
        start_date: this.start_date,
        end_date: this.end_date,
        search_all: this.search_all,
      })
        .then((res) => {
          this.loading = false
          if (res.status === 200) {
            if (res.data.code === 200) {
              this.$store.dispatch('files/setState', {
                file_items: Array.isArray(res.data.data) ? res.data.data : [],
                total: res.data.total,
                itemCount: Array.isArray(res.data.data) ? res.data.data.length : 0,
                from: res.data.from,
                to: res.data.to,
                loading: false,
              })
            }
          }
          this.$store.dispatch('files/setState', { loading: false });
        })
      return false;
    },
    getRootNodeOptions() {
      return { ...this.defaultNodeOptions };
    },
    getLeafNodeOptions() {
      const leafNodeOptions = { ...this.defaultNodeOptions };
      leafNodeOptions.isLeaf = true;
      leafNodeOptions.editNodeDisabled = false;
      leafNodeOptions.delNodeDisabled = false;
      return leafNodeOptions;
    },
    getAllCategory() {
      this.newTree = [];
      this.$store.dispatch('files/setState', {
        category_items: [],
        loading: true,
      });
      this.$store.dispatch('files/fetchAllCategory', {
        // keyword: this.keyword,
      })
        .then((res) => {
          this.loading = false
          if (res.status === 200) {
            if (res.data.code === 200) {
              // console.log('data', res.data.data);
              const rootNodeOptions = { ...this.defaultNodeOptions };

              const itemAll = {
                id: 0,
                pid: 0,
                name: 'Tất cả',
                level: 0,
                type: 'all',
                allow_delete: false,
                allow_create_sub: false,
                ...rootNodeOptions,
                children: [],
              };
              this.newTree.push(itemAll);

              res.data.data.forEach((root) => {
                let allowCreateSub = true;
                if (root.type === 'all') {
                  allowCreateSub = false;
                }
                const item = {
                  id: root.id,
                  pid: root.parent_id < 0 ? 0 : root.parent_id,
                  name: root.name,
                  level: root.level,
                  type: root.type,
                  allow_delete: false,
                  allow_create_sub: allowCreateSub,
                  ...rootNodeOptions,
                  children: [],
                };
                // console.log('root:', root);
                // force sub cat is leaf
                if (root.childs.length) {
                  root.childs.forEach((c1) => {
                    const item1 = {
                      id: c1.id,
                      pid: c1.parent_id,
                      name: c1.name,
                      level: c1.level,
                      type: c1.type,
                      allow_delete: true,
                      allow_create_sub: true,
                      ...this.getLeafNodeOptions(),
                      children: [],
                    }
                    if (c1.childs.length) {
                      c1.childs.forEach((c2) => {
                        const item2 = {
                          id: c2.id,
                          pid: c2.parent_id,
                          name: c2.name,
                          level: c2.level,
                          type: c2.type,
                          allow_delete: true,
                          allow_create_sub: true,
                          ...this.getLeafNodeOptions(),
                          children: [],
                        }
                        if (c2.childs.length) {
                          c2.childs.forEach((c3) => {
                            const item3 = {
                              id: c3.id,
                              pid: c3.parent_id,
                              name: c3.name,
                              level: c3.level,
                              type: c3.type,
                              allow_delete: true,
                              allow_create_sub: true,
                              ...this.getLeafNodeOptions(),
                              children: [],
                            }
                            if (c3.childs.length) {
                              c3.childs.forEach((c4) => {
                                const item4 = {
                                  id: c4.id,
                                  pid: c4.parent_id,
                                  name: c4.name,
                                  level: c4.level,
                                  type: c4.type,
                                  allow_delete: true,
                                  allow_create_sub: true,
                                  ...this.getLeafNodeOptions(),
                                  children: [],
                                }
                                if (c4.childs.length) {
                                  c4.childs.forEach((c5) => {
                                    const item5 = {
                                      id: c5.id,
                                      pid: c5.parent_id,
                                      name: c5.name,
                                      level: c5.level,
                                      type: c5.type,
                                      allow_delete: true,
                                      allow_create_sub: false,
                                      ...this.getLeafNodeOptions(),
                                      children: [],
                                    }
                                    item4.children.push(item5);
                                  })
                                }
                                item3.children.push(item4);
                              })
                            }
                            item2.children.push(item3);
                          })
                        }
                        item1.children.push(item2);
                      })
                    }
                    item.children.push(item1);
                  })
                }

                return this.newTree.push(item);
              });
              this.treeData = new Tree(this.newTree);
              // update right content
              this.$store.dispatch('files/setState', { category_items: this.newTree });
              // auto select all
              this.$nextTick(() => {
                this.activeNodeTree(0);
              });
            } else {
              // console.log('Not connect Mam');
            }
            this.$store.dispatch('files/setState', { loading: false });
          }
        })
    },
    addCategory(item) {
      this.getAllCategory();
    },
    deleteNodeTree(rootNodes, node) {
      if (rootNodes.length) {
        rootNodes.forEach((el, idx) => {
          if (el.id === node.id) {
            this.getAllCategory();
            return;
          } if (el.children.length) {
            this.deleteNodeTree(el.children, node);
          }
        });
      }
    },
    onEdit(node) {
      if (node.eventType === undefined) {
        this.oldName = node.oldName;
      }
      if (node.eventType === 'blur') {
        if (this.oldName !== node.newName) {
          this.$store.dispatch('files/setState', { loading: true });
          this.$store.dispatch('files/updateCategory', { data: { name: node.newName }, id: node.id })
            .then((response) => {
              if (response.status === 200) {
                if (response.data.code === 200) {
                  this.clickNodeTree(node);
                  showToast(response.data.message, { variant: 'success' });
                } else {
                  showToast(response.data.message)
                }
              }
              this.$store.dispatch('files/setState', { loading: false });
            })
        }
      }
    },
    onDel(node) {
      const el = document.getElementById(node.id);
      el.focus();
      this.$swal({
        title: 'Bạn chắc muốn xóa?',
        text: 'Xóa dữ liệu sẽ ảnh hưởng đến các chức năng khác trong hệ thống!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('files/destroyCategory', { id: node.id }).then((res) => {
            if (res.status === 200) {
              this.deleteNodeTree(this.newTree, node);
            }
          })
        }
      })
    },
    filterPem(event, clear) {
      const isClear = clear === undefined ? false : clear;
      const filter = this.searchCatQuery.toLowerCase();
      if (clear) {
        this.searchCatQuery = '';
      }
      const nodes = document.querySelectorAll('.vtl-tree-margin .vtl-node-content');
      nodes.forEach(el => {
        const parentEl = el.closest('.vtl');

        if (!isClear) {
          const nodeName = el.innerText;
          if (nodeName.toLowerCase().indexOf(filter) > -1) {
            parentEl.style.display = '';
          } else {
            parentEl.style.display = 'none';
          }
        } else {
          parentEl.style.display = '';
        }
      });
    },
  },
}
</script>
<style lang="scss">
.vtl {
  .vtl-caret {
    margin-top: 3px;
  }

  .vtl-node-main {
    padding-left: 2rem;
  }

  .vtl-tree-margin {
    margin-left: 1rem;
  }

  .vtl-node-content {
    cursor: pointer;
  }

  .vtl-node-main .vtl-operation {
    text-align: right;
    margin-left: auto;
  }

  .vtl-node-main .vtl-operation span {
    margin-right: 5px;
  }

  .vtl-node:focus {
    background-color: #f0f0f0;
  }
}
</style>
